import { getCountry } from '@iwIntlProvider/CountryProvider';
import { RootState } from '@iwProvider/configureStore';
import { GetProductOffersResponse } from '@iwoca/lapi-client/edge';
import _ from 'lodash';

type TSuggestedProduct = NonNullable<
    GetProductOffersResponse['data']
>['products'][number];

export const hasCreatedFlexiLoanApplicationInAccountPages = (
    state: RootState
) => state?.api?.customer_state?.data?.ui?.hasCreatedFlexiApplication;

export const getCompanyAnnualTurnover = (state: RootState) =>
    state?.api?.customer_state?.data?.application?.company
        ?.last_12_months_turnover?.amount;

export const hasOffer = (suggestedProduct: TSuggestedProduct) => {
    //exclude DE longer loans from autoformalising N.B product_offers duration is specified in months
    if (getCountry() === 'DE' && suggestedProduct.duration.amount > 24)
        return false;
    if (suggestedProduct.offers.length > 0) return true;
    return false;
};

export const isDeclined = (suggestedProduct: TSuggestedProduct) =>
    _.includes(
        ['hard_declined', 'soft_declined', 'automatically_rejected'],
        suggestedProduct.status
    );

export const getProductDeclineUid = (suggestedProduct: TSuggestedProduct) =>
    suggestedProduct?.product_type_decline?.uuid;
